import Backbone from 'backbone';
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { fetchAd } from '@bingads-webui-campaign/asset-inline-edit';

const edm = globalContext.requireDefault('component/edm-campaign/index');
const jsData = globalContext.require('component/js-data-campaign/index');

export const showAdStrengthPlugin = definePlugin => definePlugin('showAdStrength', [
  'config',
  'toolbar',
], (config, toolbar) => {
  const {
    buttonId = 'button-show-ad-strength',
    initShowStatus = true,
    i18n,
    scope,
  } = config.plugins.showAdStrength;

  const toolbarEditor = toolbar.gridToolbarGroup.toolbarWithItem(buttonId);
  let showAdStrength = initShowStatus;
  let adItem = null;

  const toggleAdStrength = () => {
    showAdStrength = !showAdStrength;
  };

  const updateToolbar = () => {
    toolbarEditor.update({
      id: buttonId,
      iconLeftGlyphName: showAdStrength ? 'ba-Hide3' : 'ba-View',
      text: showAdStrength ? i18n.getString('Asset_Hide_Ad_Strength') : i18n.getString('Asset_Show_Ad_Strength'),
      onClick: () => {
        toggleAdStrength();
        updateToolbar();
      },
    });
  };

  const refreshEvent = _.extend({}, Backbone.Events);

  const refreshAdItem = () => {
    fetchAd({
      edm,
      jsData,
      scope: scope.values,
    }).then((ad) => {
      // eslint-disable-next-line prefer-destructuring
      adItem = ad[0];
      refreshEvent.trigger('adItemUpdate');
    });
  };

  updateToolbar();

  if (scope && (scope.values.adType === 'ResponsiveSearch' || scope.values.adSubType === 'native')) {
    refreshAdItem();
  }

  return {
    getShowAdStrength: () => showAdStrength,
    refreshAdItem,
    getAdItem: () => adItem,
    refreshEvent,
  };
});
